<section class="main-blocks">
  <div
    class="main-blocks__wrapper"
    [ngClass]="{ 'default-lang': isDefaultLang() }"
  >
    @for (card of cards; track card.id) {
      <noda-card
        class="{{ card.id }}"
        [config]="card"
        [queryParamsHandling]="'merge'"
        [routerLink]="getLink(card) | addLangPrefix | async"
      />
    }
  </div>
</section>
<noda-banks-swiper [sm]="true" />
